const crossfadeDurationMs = 225;
const wrapper = "_35swoamtyw";
const toggle = "_35st17h3orm";
const transitionWrapper = "_35stwgl1b2";
const dropzoneContainer = "_35sd1ymqys4";

export { crossfadeDurationMs, dropzoneContainer, toggle, transitionWrapper, wrapper };
import "./organism.facit-container.style.linaria.module.css";
//# sourceMappingURL=organism.facit-container.style.js.map
